module.exports = __webpack_public_path__ + "img/circular-close.7b437795.png";